import { render, staticRenderFns } from "./Freeze.vue?vue&type=template&id=4a619f17&scoped=true"
import script from "./Freeze.vue?vue&type=script&setup=true&lang=js"
export * from "./Freeze.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Freeze.vue?vue&type=style&index=0&id=4a619f17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a619f17",
  null
  
)

export default component.exports